import React from "react";
import PropertyForm from "./PropertyForm";

export default function AddOfficeUnit() {
  return <PropertyForm type={"Add"} />;
}
